module.exports = __webpack_public_path__ + "static/media/logo.cbc49d46.svg";